import { z } from 'zod';
/** Auth wire types (ADR-0007). Shared so client and server can't drift. */
export const HandleSchema = z
    .string()
    .min(2)
    .max(32)
    .regex(/^[a-z0-9_-]+$/, 'lowercase letters, numbers, - and _ only');
export const PasswordSchema = z.string().min(10).max(200);
export const RegisterRequestSchema = z.object({
    inviteCode: z.string().min(1),
    handle: HandleSchema,
    displayName: z.string().min(1).max(60),
    password: PasswordSchema,
    deviceLabel: z.string().min(1).max(60).default('This device'),
});
export const LoginRequestSchema = z.object({
    handle: HandleSchema,
    password: z.string().min(1).max(200), // no min-length here: don't help an attacker enumerate policy
    deviceLabel: z.string().min(1).max(60).default('This device'),
});
export const AuthResponseSchema = z.object({
    accessToken: z.string(),
    expiresIn: z.number().int().positive(), // seconds, for the client's refresh timer
    user: z.object({
        id: z.string(),
        handle: z.string(),
        displayName: z.string(),
        isAdmin: z.boolean(),
    }),
    deviceId: z.string(),
});
export const CreateInviteResponseSchema = z.object({
    code: z.string(),
    expiresAt: z.number().int(),
});
export const ChangePasswordRequestSchema = z.object({
    currentPassword: z.string().min(1).max(200),
    newPassword: PasswordSchema,
});
//# sourceMappingURL=auth.js.map